import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner/DefaultBanner';

import {
  Col,
  Grid,
  Row,
} from '../../../incubation/components/ResponsiveGridLayout';

import Link from '../../../components/Link';

import s from './Team.scss';

class Team extends React.Component {
  render() {
    return (
      <React.Fragment>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/"
                >
                  <span itemProp="name">Home</span>
                </Link>
                <meta content="0" itemProp="position" />
              </li>
              <li>The Team</li>
            </ul>
          }
          header="The Team"
          subHeader="Learn about the passionate team behind Flux Tech"
        />
        <section className={s.team}>
          <Grid>
            <Row>
              <Col>
                <h2
                  className={s.globalSectionHeading}
                  style={{ textAlign: 'center' }}
                >
                  The Team Behind <strong>Flux Tech</strong>
                </h2>
                <div className={s.teamMembers}>
                  <div className={s.member}>
                    <a
                      href="https://www.linkedin.com/in/jonathan-emig/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img
                        alt="Jonathan Emig"
                        className={s.memberPhoto}
                        src="/images/uncompressed/jonathan-poster-v3.jpg"
                      />
                    </a>
                    <div className={s.memberText}>
                      <h3 className="globalCardHeading">Jonathan Emig</h3>
                      <p className={s.role}>Founder</p>
                      <p>
                        Jonathan is the founder and lead developer at Flux Tech.
                        The dream of Flux Tech started in a college dorm back in
                        2015. Jonathan's passion for tech and innovation drove
                        him to want to build software products for startups and
                        small businesses.
                      </p>
                    </div>
                  </div>

                  <div className={s.member}>
                    <a
                      href="https://www.linkedin.com/in/dhurlburtusa/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img
                        alt="Dan Hurlburt"
                        className={s.memberPhoto}
                        src="/images/uncompressed/dan-poster.png"
                      />
                    </a>
                    <div className={s.memberText}>
                      <h3 className="globalCardHeading">Dan Hurlburt</h3>
                      <p className={s.role}>Senior Fullstack Developer</p>
                      <p>
                        Dan has worked as a fullstack developer for over 15
                        years. He's an incredibly talented developer with a
                        passion for detail. He loves to dig deep into the APIs
                        he uses.
                      </p>
                    </div>
                  </div>

                  <div className={s.member}>
                    <a
                      href="https://www.linkedin.com/in/jason-pacini-087645168/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <img
                        alt="Jason Pacini"
                        className={s.memberPhoto}
                        src="/images/uncompressed/jason-poster.png"
                      />
                    </a>
                    <div className={s.memberText}>
                      <h3 className="globalCardHeading">Jason Pacini</h3>
                      <p className={s.role}>UI / UX Developer</p>
                      <p>
                        Jason's artistic vision helps Flux Tech dramatically
                        when starting new projects. He has the ability to see
                        potential where others don't and put together intuitive
                        UI's.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(Team);
